import React, { useState } from 'react';
import { Menu, Dropdown, Icon } from 'semantic-ui-react';
import { Link, useNavigate } from 'react-router-dom';

const MenuBar = ({ signOut, username }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    signOut();       // AWS Amplify sign out
    setOpen(false);  // close dropdown
    navigate('/');   // redirect to home
  };

  const handleItemClick = (path) => {
    setOpen(false);  // close dropdown
    navigate(path);
  };

  return (
    <Menu compact fixed="top" inverted
      style={{
        height: '12em',
        backgroundColor: '#302d4a',
        backgroundImage: `
          linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), 
          url('/images/mhscape.jpg')
        `,
        backgroundSize: '300px',
        backgroundPosition: 'calc(100% - 20px) center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Dropdown
        item
        text="TrekMH MBC Platform"
        position="left"
        open={open}
        onClick={() => setOpen(!open)}
        onBlur={() => setOpen(false)}  // closes when clicking outside
        style={{ fontSize: "18px" }}
      >
        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', width: '150px' }}>
          <Dropdown.Item onClick={() => handleItemClick('/')}>Home</Dropdown.Item>
          <Dropdown.Divider />

          <Dropdown.Item onClick={() => handleItemClick('/dashboard')}>Dashboard</Dropdown.Item>

          <Dropdown.Divider />
          <Dropdown.Item onClick={() => handleItemClick('/dailynotes')}>Daily Notes</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => handleItemClick('/symptomassess')}>Sleep Assessment</Dropdown.Item>
          <Dropdown.Item onClick={() => handleItemClick('/symptomassess2')}>Stress Assessment</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => handleItemClick('/pvt')}>Fatigue Test</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => handleItemClick('/dataprivacy')}>Data Privacy</Dropdown.Item>
          <Dropdown.Divider />
          {username && (
            <Dropdown.Item disabled style={{ fontWeight: 'bold', color: '#21ba45' }}>
              Account: {username}
            </Dropdown.Item>
          )}
          <Dropdown.Item onClick={handleLogout}>
            <Icon name="power off" /> Log Out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </Menu>
  );
};

export default MenuBar;
